export default (({
  message = 'This field is required'
} = {}) => value => value ? null : message);